(() => {
  const theme = window.ChambersTheme || {};
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const menu = document.querySelector('[data-mobile-menu]');
  const cartStatus = document.querySelector('[data-cart-status]');
  const currency = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: theme.currency || 'AUD' });

  function money(cents) { return currency.format((Number(cents) || 0) / 100); }
  function setOpen(element, isOpen, className) { if (element) element.classList.toggle(className, isOpen); }
  function setCartStatus(message = '', state = '') {
    if (!cartStatus) return;
    cartStatus.textContent = message;
    if (state) cartStatus.dataset.state = state;
    else delete cartStatus.dataset.state;
  }
  function openCart() { setOpen(cartDrawer, true, 'is-open'); setOpen(backdrop, true, 'is-open'); document.body.classList.add('cart-is-open'); cartDrawer?.querySelector('[data-drawer-close]')?.focus(); }
  function closeCart() { setOpen(cartDrawer, false, 'is-open'); setOpen(backdrop, false, 'is-open'); document.body.classList.remove('cart-is-open'); }
  function openMenu() { setOpen(menu, true, 'is-open'); document.body.classList.add('menu-is-open'); menu?.querySelector('[data-menu-close]')?.focus(); }
  function closeMenu() { setOpen(menu, false, 'is-open'); document.body.classList.remove('menu-is-open'); }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = String(count).padStart(2, '0'); });
  }

  function createDrawerItem(item) {
    const line = document.createElement('article');
    line.className = 'drawer-item';
    line.dataset.key = item.key;
    const image = document.createElement('div'); image.className = 'drawer-item__image';
    if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; image.appendChild(img); }
    const meta = document.createElement('div'); meta.className = 'drawer-item__meta';
    const title = document.createElement('a'); title.className = 'drawer-item__name'; title.href = item.url; title.textContent = item.product_title;
    const variant = document.createElement('span'); variant.className = 'drawer-item__variant'; variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const bottom = document.createElement('div'); bottom.className = 'drawer-item__bottom';
    const quantity = document.createElement('div'); quantity.className = 'drawer-quantity';
    const minus = document.createElement('button'); minus.type = 'button'; minus.dataset.cartChange = '-1'; minus.setAttribute('aria-label', `Remove one ${item.product_title}`); minus.textContent = '−';
    const amount = document.createElement('span'); amount.textContent = String(item.quantity);
    const plus = document.createElement('button'); plus.type = 'button'; plus.dataset.cartChange = '1'; plus.setAttribute('aria-label', `Add one ${item.product_title}`); plus.textContent = '+';
    quantity.append(minus, amount, plus);
    const price = document.createElement('span'); price.className = 'drawer-item__price'; price.textContent = money(item.final_line_price);
    bottom.append(quantity, price); meta.append(title, variant, bottom); line.append(image, meta);
    return line;
  }

  function renderCart(cart) {
    const items = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    const total = document.querySelector('[data-cart-total]');
    if (!items) return;
    items.replaceChildren();
    if (!cart.item_count) {
      const empty = document.createElement('div'); empty.className = 'drawer-empty';
      const heading = document.createElement('h2'); heading.textContent = 'YOUR BAG IS LIGHT.';
      const text = document.createElement('p'); text.textContent = 'Add something roasted, brewed, or useful.';
      const shop = document.createElement('a'); shop.className = 'primary-action'; shop.href = '/collections/all'; shop.textContent = 'Shop the shelf';
      empty.append(heading, text, shop); items.append(empty); if (footer) footer.hidden = true;
    } else {
      cart.items.forEach((item) => items.append(createDrawerItem(item)));
      if (footer) footer.hidden = false;
      if (total) total.textContent = money(cart.total_price);
    }
    updateCartCount(cart.item_count);
  }

  async function getCart() {
    const response = await fetch(`${theme.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh the bag.');
    return response.json();
  }

  async function refreshCart() { const cart = await getCart(); renderCart(cart); return cart; }
  async function changeLine(key, delta) {
    setCartStatus('Updating your bag…', 'loading');
    const cart = await getCart(); const line = cart.items.find((item) => item.key === key); if (!line) return;
    const response = await fetch(`${theme.cartUrl}/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, line.quantity + delta) }) });
    if (!response.ok) throw new Error('Unable to update the bag.'); renderCart(await response.json()); setCartStatus('Bag updated.', 'success');
  }

  async function addToCart(form) {
    const submit = form.querySelector('[type="submit"]'); const originalText = submit?.textContent;
    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
    setCartStatus('Adding this item to your bag…', 'loading');
    try {
      const response = await fetch(form.action || theme.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Please choose an available option.');
      await refreshCart(); setCartStatus('Added to your bag.', 'success'); openCart();
    } catch (error) {
      const message = error instanceof Error && error.message === 'Please choose an available option.'
        ? error.message
        : 'We could not add that item right now. Please try again.';
      setCartStatus(message, 'error'); openCart();
    }
    finally { if (submit) { submit.disabled = false; submit.textContent = originalText; } }
  }

  function beginCheckout(link) {
    if (!link || link.dataset.redirecting === 'true') return;
    link.dataset.redirecting = 'true';
    link.classList.add('is-redirecting');
    link.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Taking you to secure checkout…';
    setCartStatus('Taking you to secure Shopify checkout…', 'redirecting');
    window.setTimeout(() => window.location.assign(link.href), 90);
  }

  function attachVariantForm(form) {
    const dataElement = form.querySelector('[data-variant-data]'); if (!dataElement) return;
    let variants; try { variants = JSON.parse(dataElement.textContent); } catch { return; }
    const selects = [...form.querySelectorAll('[data-option-select]')]; const idInput = form.querySelector('[data-variant-id]'); const price = form.querySelector('[data-variant-price]'); const submit = form.querySelector('[type="submit"]'); const availability = form.closest('.product-detail')?.querySelector('[data-variant-availability]');
    const update = () => {
      const selected = selects.map((select) => select.value);
      const variant = selects.length
        ? variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]))
        : variants.find((candidate) => String(candidate.id) === String(idInput?.value)) || variants[0];
      if (idInput && variant) idInput.value = variant.id;
      if (price && variant) price.textContent = money(variant.price);
      if (availability) availability.textContent = variant?.available ? 'Available now' : 'Currently unavailable';
      if (submit) {
        submit.disabled = !variant || !variant.available;
        submit.textContent = !variant ? 'Choose options' : variant.available ? 'Add to bag' : 'Sold out';
      }
    };
    selects.forEach((select) => select.addEventListener('change', update)); update();
  }

  function adjustQuantity(button) {
    const wrapper = button.closest('.quantity-input');
    const input = wrapper?.querySelector('input[type="number"]');
    if (!input) return;
    const current = Number(input.value || 1);
    const minimum = Number(input.min || 1);
    input.value = String(Math.max(minimum, current + Number(button.dataset.quantityAdjust || 0)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', async (event) => {
    const target = event.target.closest('[data-cart-toggle],[data-drawer-close],[data-drawer-backdrop],[data-menu-toggle],[data-menu-close],[data-cart-change],[data-quantity-adjust],[data-checkout-link]');
    if (!target) return;
    if (target.matches('[data-cart-toggle]')) { event.preventDefault(); openCart(); }
    if (target.matches('[data-drawer-close],[data-drawer-backdrop]')) { event.preventDefault(); closeCart(); }
    if (target.matches('[data-menu-toggle]')) { event.preventDefault(); openMenu(); }
    if (target.matches('[data-menu-close]')) { event.preventDefault(); closeMenu(); }
    if (target.matches('[data-cart-change]')) { event.preventDefault(); try { await changeLine(target.closest('[data-key]')?.dataset.key, Number(target.dataset.cartChange)); } catch { setCartStatus('Unable to update the bag. Please try again.', 'error'); } }
    if (target.matches('[data-quantity-adjust]')) { event.preventDefault(); adjustQuantity(target); }
    if (target.matches('[data-checkout-link]')) { event.preventDefault(); beginCheckout(target); }
  });
  document.addEventListener('submit', (event) => { const form = event.target.closest('[data-product-form]'); if (!form) return; event.preventDefault(); addToCart(form); });
  document.addEventListener('keydown', (event) => { if (event.key !== 'Escape') return; closeCart(); closeMenu(); });
  document.querySelectorAll('[data-product-variant-form]').forEach(attachVariantForm);
})();
